module.exports = __webpack_public_path__ + "static/media/book.5e362744.svg";